module.exports = __webpack_public_path__ + "img/phenopackets-ecosystem2.129bc61d.png";